import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { products } from '@/mocks/products';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProductGallery from './components/ProductGallery';
import ProductInfo from './components/ProductInfo';
import RelatedProducts from './components/RelatedProducts';

const ProductPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();
  const product = products.find(p => p.slug === slug);

  const relatedProducts = product
    ? products.filter(p => p.category === product.category)
    : [];

  if (!product) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
          <div className="text-center">
            <p className="text-white/40 text-sm mb-4">{t('product_not_found', 'Produto não encontrado')}</p>
            <Link to="/loja" className="text-[#c9a84c] text-xs tracking-widest uppercase">
              {t('product_back_shop', 'Voltar à loja')}
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const galleryImages = product.gallery && product.gallery.length > 0
    ? product.gallery
    : [product.image];

  return (
    <>
      <Navbar />
      <main className="bg-[#0a0a0a] min-h-screen pt-[72px]">
        {/* Breadcrumb */}
        <div className="px-6 md:px-10 py-4 border-b border-white/6">
          <div className="max-w-7xl mx-auto flex items-center gap-2 text-[10px] text-white/25 tracking-widest uppercase flex-wrap">
            <Link to="/" className="hover:text-[#c9a84c] transition-colors whitespace-nowrap">
              {t('nav_home', 'Home')}
            </Link>
            <i className="ri-arrow-right-s-line text-white/20"></i>
            <Link to="/loja" className="hover:text-[#c9a84c] transition-colors whitespace-nowrap">
              {t('nav_shop', 'Loja')}
            </Link>
            <i className="ri-arrow-right-s-line text-white/20"></i>
            {product.category === 'whisky' ? (
              <Link to="/whiskies" className="hover:text-[#c9a84c] transition-colors whitespace-nowrap">
                {t('nav_whiskies', 'Whiskies')}
              </Link>
            ) : (
              <Link to="/gins" className="hover:text-[#c9a84c] transition-colors whitespace-nowrap">
                {t('nav_gins', 'Gins')}
              </Link>
            )}
            <i className="ri-arrow-right-s-line text-white/20"></i>
            <span className="text-white/50 whitespace-nowrap">{product.name}</span>
          </div>
        </div>

        {/* Main product section */}
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-20 items-start">
            {/* Gallery */}
            <div className="lg:sticky lg:top-24">
              <ProductGallery
                images={galleryImages}
                productName={product.name}
                badge={product.badge}
              />
            </div>

            {/* Info */}
            <ProductInfo product={product} />
          </div>
        </div>

        {/* Related products */}
        <RelatedProducts products={relatedProducts} currentSlug={product.slug} />
      </main>
      <Footer />
    </>
  );
};

export default ProductPage;
